import { Operation } from '../../../__generated__/globalTypes'

import {
  AccountFragment,
  accountFragmentString,
} from '../../fragments/__generated__/AccountFragment'

import { promptingsCoachFragmentString } from '../../fragments/__generated__/PromptingsCoachFragment'

import { bankAccountFragmentString } from '../../fragments/__generated__/BankAccountFragment'

import { addressFragmentString } from '../../fragments/__generated__/AddressFragment'

import { storefrontString } from '../../fragments/__generated__/Storefront'

import { minimalSponsorFragmentString } from '../../fragments/__generated__/MinimalSponsorFragment'

import { stripeSubscriptionString } from '../../fragments/__generated__/StripeSubscription'

import { subscriptionMetadataString } from '../../fragments/__generated__/SubscriptionMetadata'

import { expenseReloadString } from '../../fragments/__generated__/ExpenseReload'

import { creditCardBillingAddressFragmentString } from '../../fragments/__generated__/CreditCardBillingAddressFragment'

import { amountString } from '../../fragments/__generated__/Amount'

import { stripeSourceFragmentString } from '../../fragments/__generated__/StripeSourceFragment'

import { planFragmentString } from '../../fragments/__generated__/PlanFragment'

import { creditCardFragmentString } from '../../fragments/__generated__/CreditCardFragment'

import { subscriptionFeaturesString } from '../../fragments/__generated__/SubscriptionFeatures'

import { userSettingsFragmentString } from '../../fragments/__generated__/UserSettingsFragment'

import getAccountRawString from '../GetAccount.graphql'

const getAccountString = [
  getAccountRawString,
  accountFragmentString,
  promptingsCoachFragmentString,
  bankAccountFragmentString,
  addressFragmentString,
  storefrontString,
  minimalSponsorFragmentString,
  stripeSubscriptionString,
  subscriptionMetadataString,
  expenseReloadString,
  creditCardBillingAddressFragmentString,
  amountString,
  stripeSourceFragmentString,
  planFragmentString,
  creditCardFragmentString,
  subscriptionFeaturesString,
  userSettingsFragmentString,
].join('\n\n')

export type GetAccountData = {
  account: AccountFragment
}

export type GetAccount = Operation<GetAccountData>

export const GetAccount = (): GetAccount => ({
  query: getAccountString,
  variables: undefined,
})
